import { useMemo } from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'
import { DEFAULT_SITE_URL, getSeoForPath } from '@/seo'

const resolveBaseUrl = () => {
  if (typeof window !== 'undefined' && window.location?.origin) {
    return window.location.origin
  }

  if (import.meta?.env?.VITE_PUBLIC_SITE_URL) {
    return import.meta.env.VITE_PUBLIC_SITE_URL
  }

  return DEFAULT_SITE_URL
}

export function SeoUpdater() {
  const location = useLocation()
  const baseUrl = resolveBaseUrl()

  const metadata = useMemo(
    () => getSeoForPath(location.pathname, { baseUrl }),
    [location.pathname, baseUrl]
  )

  return (
    <Helmet prioritizeSeoTags>
      <title>{metadata.title}</title>
      <meta name="description" content={metadata.description} />
      {metadata.canonicalUrl && (
        <link rel="canonical" href={metadata.canonicalUrl} />
      )}

      <meta property="og:type" content={metadata.ogType || 'website'} />
      <meta property="og:title" content={metadata.title} />
      <meta property="og:description" content={metadata.description} />
      <meta property="og:image" content={metadata.image} />
      {metadata.locale && <meta property="og:locale" content={metadata.locale} />}
      {metadata.canonicalUrl && (
        <meta property="og:url" content={metadata.canonicalUrl} />
      )}

      <meta name="twitter:card" content={metadata.twitterCard || 'summary_large_image'} />
      <meta name="twitter:title" content={metadata.title} />
      <meta name="twitter:description" content={metadata.description} />
      <meta name="twitter:image" content={metadata.image} />
    </Helmet>
  )
}
